<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('last_news.title'),
            subtitle: {
                first_text: $t('last_news.label'),
                first_href: '/',
                second_text: $t('last_news.title')
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-12 mb-3" v-for="item in news" :key="item.id">
                    <HorizontalCard :item="item" />

                </div>
            </div>
            <PagesPagination/>
        </div>

        <AppFooter />

    </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import PagesHero from '@/components/PagesHero.vue';
import HorizontalCard from "../components/News/HorizontalCard.vue";
import Home from "../api/home";
import PagesPagination from "../components/Pagination/PagesPagination.vue";


export default {
    async created() {
        let news = await new Home().News({ per_page: 4 })
        this.news = news.data
    },
    components: {
        AppNavbar, PagesHero, AppFooter, HorizontalCard, PagesPagination
    },
    data() {
        return {
            news: []
        }
    }
}

</script>

<style scoped>
.row {
    margin-top: 40px;
}



.container {
    padding-bottom: 80px;
}
</style>